import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container" };
import SiteSearch from '../../front/components/SiteSearch/SiteSearch.vue';
import { Search } from './Search';
import { theme } from '../../front/Theme';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SearchApp',
    props: {
        searchLayout: {}
    },
    setup(__props) {
        const props = __props;
        const url = new URL(window.location.href);
        const maybeInitialIndexUid = (url.searchParams.get(Search.UriParam.IndexUid) || props.searchLayout.json.active_index_uid);
        const initialIndexUid = theme().json.meilisearch.indexes.some(i => i.uid === maybeInitialIndexUid)
            ? maybeInitialIndexUid
            : null;
        function onChange(args) {
            const url = new URL(window.location.href);
            if (typeof args.indexUid !== 'undefined') {
                if (args.indexUid) {
                    url.searchParams.set(Search.UriParam.IndexUid, args.indexUid);
                }
                else if (url.searchParams.has(Search.UriParam.IndexUid)) {
                    url.searchParams.delete(Search.UriParam.IndexUid);
                }
            }
            if (typeof args.query !== 'undefined') {
                url.searchParams.set(Search.UriParam.Query, args.query);
            }
            if (url.href !== window.location.href) {
                window.history.replaceState({}, '', url.href);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SiteSearch, {
                    "initial-index-uid": _unref(initialIndexUid),
                    query: _ctx.searchLayout.json.query,
                    "auto-focus-input": true,
                    onIndexChange: _cache[0] || (_cache[0] = ($event) => (onChange({ indexUid: $event }))),
                    onQueryChange: _cache[1] || (_cache[1] = ($event) => (onChange({ query: $event })))
                }, null, 8, ["initial-index-uid", "query"])
            ]));
        };
    }
});
